import { Injectable } from '@angular/core';
import { Http, Request, Response, RequestOptions, RequestMethod } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { HeaderFactory } from '../../common/HeaderFactory';

declare const OUTCOMES_API: string;

@Injectable()
export class ResultExportService {
    constructor(
        private http: Http, 
        private headerFactory: HeaderFactory
    ) {
        //
    }

    export(institutionId: number) : Observable<Response> {
        return this.http.get(OUTCOMES_API + '/result-export/' + institutionId, {
            headers: this.headerFactory.make()
        });
    }
}


/** WEBPACK FOOTER **
 ** ./app/export/services/ResultExportService.ts
 **/